// --- Büsche generieren
window.bushesData = [
  { top: 200, left: -200, rotate: 270 },
  { top: 450, left: -200, rotate: 270 },
  { top: 700, left: -200, rotate: 270 },
  { top: 950, left: -200, rotate: 270 },
  { top: 1200, left: -200, rotate: 270 },
  { top: 0, left: 0, rotate: 0 },
  { top: 0, left: 250, rotate: 0 },
  { top: 0, left: 500, rotate: 0 },
  { top: 0, left: 750, rotate: 0 },
  { top: 0, left: 1000, rotate: 0 },
  { top: 0, left: 1250, rotate: 0 },
  { top: 0, left: 1500, rotate: 0 },
  { top: 0, left: 1750, rotate: 0 },
  { top: 0, left: 2000, rotate: 0 },
  { top: 0, left: 2250, rotate: 0 },
  { top: 0, left: 2500, rotate: 0 },
  { top: 0, left: 2750, rotate: 0 },
  { top: 0, left: 3000, rotate: 0 },
  { top: 0, left: 3250, rotate: 0 },
  { top: 0, left: 3500, rotate: 0 },
  { top: 0, left: 3750, rotate: 0 },
  { top: 0, left: 4000, rotate: 0 },
  { top: 700, left: 400, rotate: 270 },
  { top: 500, left: 500, rotate: 0 },
  { top: 500, left: 750, rotate: 0 },
  { top: 500, left: 1000, rotate: 0 },
  { top: 500, left: 1750, rotate: 0 },
  { top: 500, left: 2000, rotate: 0 },
  { top: 270, left: 2100, rotate: 270 },
  { top: 1000, left: -50, rotate: 0 },
  { top: 1000, left: 200, rotate: 0 },
  { top: 1000, left: 450, rotate: 0 },
  { top: 1000, left: 700, rotate: 0 },
  { top: 1000, left: 950, rotate: 0 },
  { top: 1000, left: 1200, rotate: 0 },
  { top: 1000, left: 1450, rotate: 0 },
  { top: 1000, left: 2250, rotate: 0 },
  { top: 1000, left: 2500, rotate: 0 },
  { top: 1000, left: 2750, rotate: 0 },
  { top: 150, left: 2800, rotate: 270 },
  { top: 400, left: 2800, rotate: 270 },
  { top: 650, left: 2800, rotate: 270 },
  { top: 900, left: 2800, rotate: 270 },
  { top: 1500, left: 2750, rotate: 0 },
  { top: 1500, left: 2750, rotate: 0 },

  { top: 1500, left: 0, rotate: 0 },

  { top: 1500, left: 750, rotate: 0 },
  { top: 1500, left: 1000, rotate: 0 },
  { top: 1500, left: 1250, rotate: 0 },
  { top: 1500, left: 1500, rotate: 0 },
  { top: 1500, left: 1750, rotate: 0 },
  { top: 1500, left: 2000, rotate: 0 },
  { top: 1500, left: 2250, rotate: 0 },
  { top: 1500, left: 2500, rotate: 0 },
  { top: 1500, left: 2750, rotate: 0 },
  { top: 1500, left: 3000, rotate: 0 },
  { top: 1500, left: 3250, rotate: 0 },

  { top: 700, left: 3300, rotate: 270 },
  { top: 900, left: 3300, rotate: 270 },
  { top: 1150, left: 3300, rotate: 270 },
  { top: 1400, left: 3300, rotate: 270 },

  { top: 1750, left: 50, rotate: 270 },
  { top: 2000, left: 50, rotate: 270 },
  { top: 2250, left: 50, rotate: 270 },
  { top: 2500, left: 50, rotate: 270 },
  { top: 2750, left: 50, rotate: 270 },

  { top: 1750, left: 700, rotate: 270 },
  { top: 2000, left: 700, rotate: 270 },
  { top: 2250, left: 700, rotate: 270 },
  { top: 2500, left: 700, rotate: 270 },

  { top: 3000, left: 200, rotate: 0 },
  { top: 3000, left: 450, rotate: 0 },
  { top: 3000, left: 700, rotate: 0 },
  { top: 3000, left: 1450, rotate: 0 },
  { top: 3000, left: 1700, rotate: 0 },
  { top: 3000, left: 1950, rotate: 0 },
  { top: 3000, left: 2700, rotate: 0 },
  { top: 3000, left: 2900, rotate: 0 },
  { top: 3000, left: 3200, rotate: 0 },

  { top: 2750, left: 3300, rotate: 270 },
  { top: 2500, left: 3300, rotate: 270 },
  { top: 2250, left: 3300, rotate: 270 },
  { top: 2000, left: 3300, rotate: 270 },

  { top: 2550, left: 1000, rotate: 0 },
  { top: 2550, left: 1250, rotate: 0 },
  { top: 2550, left: 1500, rotate: 0 },
  { top: 2550, left: 1750, rotate: 0 },
  { top: 2550, left: 2000, rotate: 0 },
  { top: 2550, left: 2250, rotate: 0 },
  { top: 2550, left: 2500, rotate: 0 },
  { top: 2550, left: 2750, rotate: 0 },
  { top: 2550, left: 3000, rotate: 0 },
  { top: 2550, left: 3250, rotate: 0 },
];
